import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderBuscadorComponent } from "./header-buscador.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreCommonModule } from "@core/common.module";
import { RouterModule } from "@angular/router";
import { CorePipesModule } from "@core/pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { CardSnippetModule } from "@core/components/card-snippet/card-snippet.module";
import { CoreDirectivesModule } from "@core/directives/directives";
import { NgxGalleryModule } from "@kolkov/ngx-gallery";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";

@NgModule({
  declarations: [HeaderBuscadorComponent],
  imports: [
    CommonModule,
    CoreCommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CardSnippetModule,
    CoreDirectivesModule,
    NgxGalleryModule,
    SweetAlert2Module.forRoot(),
    CorePipesModule,
  ],
  exports: [HeaderBuscadorComponent],
})
export class HeaderBuscadorModule {}
